var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loadingList
        ? _c(
            "div",
            { staticClass: "eu-pa_6 eu-align_center" },
            [_c("emd-loader", { attrs: { type: "_invert" } })],
            1
          )
        : _c("div", { staticClass: "el-section" }, [
            _c("div", { staticClass: "emd-container _highlight_header" }, [
              _c("div", { staticClass: "emd-container__header" }, [
                _c("h2", { staticClass: "emd-text _size_section" }, [
                  _vm._v(" " + _vm._s(_vm.$t("customer.info.title")) + " "),
                ]),
              ]),
              _c("div", { staticClass: "emd-container__content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("customer.info.general-data")) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_subtle _type_label _size_tiny",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("customer.info.id")) + " "
                            ),
                          ]
                        ),
                        _c("span", [_vm._v(_vm._s(_vm.customer.id || "-"))]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_subtle _type_label _size_tiny",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("customer.info.code")) + " "
                            ),
                          ]
                        ),
                        _c("span", [_vm._v(_vm._s(_vm.customer.code || "-"))]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_subtle _type_label _size_tiny",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("customer.info.name")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          { attrs: { "data-testid": "customer-name" } },
                          [_vm._v(_vm._s(_vm.customer.name || "-"))]
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_subtle _type_label _size_tiny",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("customer.info.document")) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", [
                          _vm._v(_vm._s(_vm.customer.document || "-")),
                        ]),
                        _vm.customer.type && _vm.language === "pt-BR"
                          ? _c("span", [
                              _vm._v(
                                " - " +
                                  _vm._s(_vm.$t("customer.info.person")) +
                                  " " +
                                  _vm._s(_vm.customer.type || "-")
                              ),
                            ])
                          : _vm._e(),
                        _vm.customer.type && _vm.language === "en-US"
                          ? _c("span", [
                              _vm._v(
                                " - " +
                                  _vm._s(_vm.customer.type || "-") +
                                  " " +
                                  _vm._s(_vm.$t("customer.info.person")) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_subtle _type_label _size_tiny",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("customer.info.email")) + " "
                            ),
                          ]
                        ),
                        _c("span", [_vm._v(_vm._s(_vm.customer.email || "-"))]),
                      ]),
                      _vm.customer.phones && _vm.customer.phones.home_phone
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("customer.info.phone")) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.customer.phones.home_phone.country_code
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.customer.phones.home_phone.area_code
                                  ) +
                                  " " +
                                  _vm._s(_vm.customer.phones.home_phone.number)
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.customer.phones && _vm.customer.phones.mobile_phone
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _type_label _color_subtle _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("customer.info.mobile-phone")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.customer.phones.mobile_phone.country_code
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.customer.phones.mobile_phone.area_code
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.customer.phones.mobile_phone.number
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_subtle _type_label _size_tiny",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("customer.info.created-at")) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("dateFormat")(
                                _vm.customer.created_at,
                                "dateAndHour"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_subtle _type_label _size_tiny",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("customer.info.updated-at")) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("dateFormat")(
                                _vm.customer.updated_at,
                                "dateAndHour"
                              )
                            )
                          ),
                        ]),
                      ]),
                      Object.entries(_vm.customer.metadata).length
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _color_subtle _type_label _size_tiny",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("customer.info.more-info")) +
                                    " "
                                ),
                              ]
                            ),
                            _c("pre", [_vm._v(_vm._s(_vm.customer.metadata))]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
      _vm.permissionIsEnabled("customer.addresses:get")
        ? _c("div", { staticClass: "el-section" }, [
            _c(
              "div",
              {
                staticClass:
                  "emd-container _highlight_header _footer_spaced_sm",
              },
              [
                _c("div", { staticClass: "emd-container__header" }, [
                  _c("h2", { staticClass: "emd-text _size_section" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("customer.info.addresses.title")) +
                        " "
                    ),
                  ]),
                ]),
                _vm.loadingList
                  ? _c(
                      "div",
                      { staticClass: "eu-pa_6 eu-align_center" },
                      [_c("emd-loader", { attrs: { type: "_invert" } })],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "emd-table-responsive" },
                      [
                        _c("Table", {
                          attrs: {
                            fields: _vm.fields,
                            items: _vm.addresses.items,
                          },
                        }),
                        !_vm.loadingList && _vm.showEmptyList()
                          ? _c("empty-list", { staticClass: "eu-pb_3" })
                          : _vm._e(),
                      ],
                      1
                    ),
                !_vm.loadingList
                  ? _c("pagination", {
                      attrs: {
                        pagination: _vm.addresses.pagination,
                        totalShowing: _vm.totalItems,
                        type: "list",
                        action: _vm.action,
                        entity: "customerId",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.customer
        ? _c("log-links", {
            attrs: {
              entity: _vm.customer,
              title: _vm.$t("log-links.customer"),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }